<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">계약관리</span>
            <span class="txt">핏투데이케어에 가입한 업체 계약 및 결제정보 등록, 수정, 삭제가 가능합니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">상품설정</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">가입프로그램</span></span>
            <div class="com-table-content">
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 120px" />
                        <col style="width: 320px" />
                        <col style="width: 160px" />
                        <col style="width: 180px" />
                        <col style="width: 480px" />
                        <col style="width: 64px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>계약유형</th>
                            <th>상품명</th>
                            <th>사용기간</th>
                            <th>금액</th>
                            <th>사용메뉴</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- 베이직 -->
                        <tr v-for="(prod, idx) in basicList" v-if="basicList.length > 0">
                            <!-- 베이직 상품이 존재할 때 출력 -->
                            <td v-if="idx === 0" v-bind:rowspan="basicList.length">베이직</td>
                            <td>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-1`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="P"
                                        />
                                        <label :for="`radio-${prod.f_id}-1`">선 결제</label>
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-2`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="M"
                                        />
                                        <label :for="`radio-${prod.f_id}-2`">월 결제</label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <input v-model="prod.f_namee" class="w100p" type="text" />
                            </td>
                            <td>
                                <input
                                    v-model="prod.f_use_period"
                                    class="w85 center"
                                    maxlength="2"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <span class="txt">개월</span>
                            </td>
                            <td>
                                <input
                                    v-model="prod.f_price"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeProductPrice(prod)"
                                />
                                <span class="txt">원</span>
                            </td>
                            <td class="align-left">
                                <check-form
                                    :check-data="['스케줄', '회원', '수업', '매출', '급여', '통계']"
                                    :check-field-names="[
                                        'f_m_schd_yn',
                                        'f_m_cust_yn',
                                        'f_m_lesson_yn',
                                        'f_m_sale_yn',
                                        'f_m_pay_yn',
                                        'f_m_stat_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_schd_yn,
                                        prod.f_m_cust_yn,
                                        prod.f_m_lesson_yn,
                                        prod.f_m_sale_yn,
                                        prod.f_m_pay_yn,
                                        prod.f_m_stat_yn,
                                    ]"
                                    v-on:on-change="onChangeBasicCheck"
                                ></check-form>
                                <check-form
                                    :check-data="['히스토리', '업무게시판', '터치출석', '회원예약 APP']"
                                    :check-field-names="[
                                        'f_m_history_yn',
                                        'f_m_board_yn',
                                        'f_m_touch_yn',
                                        'f_m_resv_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_history_yn,
                                        prod.f_m_board_yn,
                                        prod.f_m_touch_yn,
                                        prod.f_m_resv_yn,
                                    ]"
                                    v-on:on-change="onChangeBasicCheck"
                                ></check-form>
                            </td>
                            <td>
                                <button class="com-btn" @click="onClickModifyProgram(prod.f_id, 'basic')">수정</button>
                            </td>
                        </tr>

                        <!-- 스탠다드 -->
                        <tr v-for="(prod, idx) in standardList" v-if="standardList.length > 0">
                            <!-- 베이직 상품이 존재할 비즈니스력 -->
                            <td v-if="idx === 0" v-bind:rowspan="standardList.length">스탠다드</td>
                            <td>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-1`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="P"
                                        />
                                        <label :for="`radio-${prod.f_id}-1`">선 결제</label>
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-2`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="M"
                                        />
                                        <label :for="`radio-${prod.f_id}-2`">월 결제</label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <input v-model="prod.f_namee" class="w100p" type="text" />
                            </td>
                            <td>
                                <input
                                    v-model="prod.f_use_period"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <span class="txt">개월</span>
                            </td>
                            <td>
                                <input
                                    v-model="prod.f_price"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeProductPrice(prod)"
                                />
                                <span class="txt">원</span>
                            </td>
                            <td class="align-left">
                                <check-form
                                    :check-data="['스케줄', '회원', '수업', '매출', '급여', '통계']"
                                    :check-field-names="[
                                        'f_m_schd_yn',
                                        'f_m_cust_yn',
                                        'f_m_lesson_yn',
                                        'f_m_sale_yn',
                                        'f_m_pay_yn',
                                        'f_m_stat_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_schd_yn,
                                        prod.f_m_cust_yn,
                                        prod.f_m_lesson_yn,
                                        prod.f_m_sale_yn,
                                        prod.f_m_pay_yn,
                                        prod.f_m_stat_yn,
                                    ]"
                                    v-on:on-change="onChangeStandardCheck"
                                ></check-form>
                                <check-form
                                    :check-data="['히스토리', '업무게시판', '터치출석', '회원예약 APP']"
                                    :check-field-names="[
                                        'f_m_history_yn',
                                        'f_m_board_yn',
                                        'f_m_touch_yn',
                                        'f_m_resv_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_history_yn,
                                        prod.f_m_board_yn,
                                        prod.f_m_touch_yn,
                                        prod.f_m_resv_yn,
                                    ]"
                                    v-on:on-change="onChangeStandardCheck"
                                ></check-form>
                            </td>
                            <td>
                                <button class="com-btn" @click="onClickModifyProgram(prod.f_id, 'standard')">
                                    수정
                                </button>
                            </td>
                        </tr>

                        <!-- 모바일 -->
                        <tr v-for="(prod, idx) in mobileList" v-if="mobileList.length > 0">
                            <!-- 베이직 상품이 존재할 비즈니스력 -->
                            <td v-if="idx === 0" v-bind:rowspan="mobileList.length">모바일</td>
                            <td>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-1`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="P"
                                        />
                                        <label :for="`radio-${prod.f_id}-1`">선 결제</label>
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-2`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="M"
                                        />
                                        <label :for="`radio-${prod.f_id}-2`">월 결제</label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <input v-model="prod.f_namee" class="w100p" type="text" />
                            </td>
                            <td>
                                <input
                                    v-model="prod.f_use_period"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <span class="txt">개월</span>
                            </td>
                            <td>
                                <input
                                    :value="prod.f_price | numberFormatFilter"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeProductPrice(prod)"
                                />
                                <span class="txt">원</span>
                            </td>
                            <td class="align-left">
                                <check-form
                                    :check-data="['스케줄', '회원', '수업', '매출', '급여', '통계']"
                                    :check-field-names="[
                                        'f_m_schd_yn',
                                        'f_m_cust_yn',
                                        'f_m_lesson_yn',
                                        'f_m_sale_yn',
                                        'f_m_pay_yn',
                                        'f_m_stat_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_schd_yn,
                                        prod.f_m_cust_yn,
                                        prod.f_m_lesson_yn,
                                        prod.f_m_sale_yn,
                                        prod.f_m_pay_yn,
                                        prod.f_m_stat_yn,
                                    ]"
                                    v-on:on-change="onChangeMobileCheck"
                                ></check-form>
                                <check-form
                                    :check-data="['히스토리', '업무게시판', '터치출석', '회원예약 APP']"
                                    :check-field-names="[
                                        'f_m_history_yn',
                                        'f_m_board_yn',
                                        'f_m_touch_yn',
                                        'f_m_resv_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_history_yn,
                                        prod.f_m_board_yn,
                                        prod.f_m_touch_yn,
                                        prod.f_m_resv_yn,
                                    ]"
                                    v-on:on-change="onChangeMobileCheck"
                                ></check-form>
                            </td>
                            <td>
                                <button class="com-btn" @click="onClickModifyProgram(prod.f_id, 'mobile')">수정</button>
                            </td>
                        </tr>

                        <!-- 프리미엄 -->
                        <tr v-for="(prod, idx) in premiumList" v-if="premiumList.length > 0">
                            <td v-if="idx === 0" v-bind:rowspan="premiumList.length">프리미엄</td>
                            <td>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-1`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="P"
                                        />
                                        <label :for="`radio-${prod.f_id}-1`">선 결제</label>
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-${prod.f_id}-2`"
                                            v-model="prod.f_pg_pay_type_cd"
                                            type="radio"
                                            value="M"
                                        />
                                        <label :for="`radio-${prod.f_id}-2`">월 결제</label>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <input v-model="prod.f_namee" class="w100p" type="text" />
                            </td>
                            <td>
                                <input
                                    v-model="prod.f_use_period"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <span class="txt">개월</span>
                            </td>
                            <td>
                                <input
                                    :value="prod.f_price"
                                    class="w85 center"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeProductPrice(prod)"
                                />
                                <span class="txt">원</span>
                            </td>
                            <td class="align-left">
                                <check-form
                                    :check-data="['스케줄', '회원', '수업', '매출', '급여', '통계']"
                                    :check-field-names="[
                                        'f_m_schd_yn',
                                        'f_m_cust_yn',
                                        'f_m_lesson_yn',
                                        'f_m_sale_yn',
                                        'f_m_pay_yn',
                                        'f_m_stat_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_schd_yn,
                                        prod.f_m_cust_yn,
                                        prod.f_m_lesson_yn,
                                        prod.f_m_sale_yn,
                                        prod.f_m_pay_yn,
                                        prod.f_m_stat_yn,
                                    ]"
                                    v-on:on-change="onChangePremiumCheck"
                                ></check-form>
                                <check-form
                                    :check-data="['히스토리', '업무게시판', '터치출석', '회원예약 APP']"
                                    :check-field-names="[
                                        'f_m_history_yn',
                                        'f_m_board_yn',
                                        'f_m_touch_yn',
                                        'f_m_resv_yn',
                                    ]"
                                    :check-id="prod.f_id"
                                    :check-values="[
                                        prod.f_m_history_yn,
                                        prod.f_m_board_yn,
                                        prod.f_m_touch_yn,
                                        prod.f_m_resv_yn,
                                    ]"
                                    v-on:on-change="onChangePremiumCheck"
                                ></check-form>
                            </td>
                            <td>
                                <button class="com-btn" @click="onClickModifyProgram(prod.f_id, 'premium')">
                                    수정
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">문자서비스</span></span>
            <table class="com-table free-size">
                <colgroup>
                    <col style="width: 220px" />
                    <col style="width: 320px" />
                    <col style="width: 65px" />
                </colgroup>
                <tbody>
                    <tr>
                        <td><strong>1개월 당 금액</strong></td>
                        <td>
                            <input
                                v-model="product.mms.f_price"
                                class="center w195"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangeMmsPrice"
                            />
                            <span class="txt">원</span>
                        </td>
                        <td>
                            <button class="com-btn" @click="onClickModifyMms">수정</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">부가서비스</span></span>
            <table class="com-table free-size">
                <colgroup>
                    <col style="width: 400px" />
                    <col style="width: 280px" />
                    <col style="width: 200px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>서비스명</th>
                        <th>금액</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- 부가서비스 목록 -->
                    <tr v-for="(addSrvRow, index) in editField.additionalServiceRows">
                        <td>
                            <input v-model="addSrvRow.name" class="w100p" type="text" />
                        </td>
                        <td>
                            <input
                                v-model="addSrvRow.price"
                                class="center w195"
                                type="text"
                                @keypress="isNumber($event)"
                                @keyup="onChangeAddSrvPrice(addSrvRow)"
                            />
                            <span class="txt">원</span>
                        </td>
                        <td>
                            <button class="com-btn" @click="onClickModifyAdditionalService(addSrvRow.id)">수정</button>
                            <button class="com-btn red" @click="onClickDeleteAdditionalService(index)">삭제</button>
                        </td>
                    </tr>
                    <!-- 부가서비스 등록 -->
                    <tr v-for="(addSrvRow, index) in editField.additionalServiceEmptyRows">
                        <td>
                            <input v-model="addSrvRow.name" class="w100p" type="text" />
                        </td>
                        <td>
                            <input v-model="addSrvRow.price" class="center w195" type="text" />
                            <span class="txt">원</span>
                        </td>
                        <td>
                            <button class="com-btn blue" @click="onClickPostAdditionalService(index)">등록</button>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <button class="com-btn blue big" @click="onClickAddAdditionalService">
                                부가서비스 추가
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'businessContractProduct',
    props: {},
    computed: {
        basicList: {
            get() {
                return this.product.program.basic;
            },
        },
        standardList: {
            get() {
                return this.product.program.standard;
            },
        },
        mobileList: {
            get() {
                return this.product.program.mobile;
            },
        },
        premiumList: {
            get() {
                return this.product.program.premium;
            },
        },
    },
    data() {
        return {
            isLoading: false,
            product: {
                program: {
                    basic: [],
                    standard: [],
                    mobile: [],
                    premium: [],
                },
                mms: {},
                additional: [],
            },
            editField: {
                additionalServiceRows: [],
                additionalServiceEmptyRows: [],
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                this.isLoading = true;

                const { data } = await this.getProductList();
                this.reorganizeData(data);

                // 테스트 구현
                this.initAdditionalService();

                this.isLoading = false;
                console.log('===> Success Loading productList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getProductList() {
            // 스웨거 검색: FT상품 목록 조회
            return api.get('/admin/api/ft/product', {
                params: {},
            });
        },
        reorganizeData(data) {
            // 데이터를 각각의 상품 데이터에 입력
            const { product } = this;

            for (const d of data) {
                switch (d.f_prod_type_cd) {
                    case 'P': // 프로그램
                        this.reorganizeProgram(d);
                        break;
                    case 'M': // 문자서비스
                        d.f_price = Utils.getNumberFormat(d.f_price);
                        product.mms = d;
                        break;
                    case 'B': // 부가서비스
                        d.f_price = Utils.getNumberFormat(d.f_price);
                        product.additional.push(d);
                        break;
                }
            }
        },
        reorganizeProgram(data) {
            const { program } = this.product;
            data.f_price = Utils.getNumberFormat(data.f_price);
            switch (data.f_pg_type_cd) {
                case 'N': // 베이직
                    program.basic.push(data);
                    break;
                case 'B': // 스탠다드
                    program.standard.push(data);
                    break;
                case 'M': // 모바일
                    program.mobile.push(data);
                    break;
                case 'S': // 프리미엄
                    program.premium.push(data);
                    break;
            }
        },
        initAdditionalService() {
            const { additional } = this.product;

            const data = [];
            for (const d of additional) {
                data.push({
                    name: d.f_namee,
                    price: d.f_price,
                    id: d.f_id,
                });
            }

            this.editField.additionalServiceRows = [...data];
        },
        changeMenuYnValue(programName, id, fieldName, value) {
            console.log(programName, id, fieldName, value);
            const list = this.product.program[programName];
            for (const l of list) {
                if (l.f_id == id && l[fieldName] !== undefined) {
                    l[fieldName] = value;
                    break;
                }
            }
        },
        onChangeBasicCheck(params) {
            const { id, value, fieldName } = params;
            this.changeMenuYnValue('basic', id, fieldName, value);
        },
        onChangeStandardCheck(params) {
            const { id, value, fieldName } = params;
            this.changeMenuYnValue('standard', id, fieldName, value);
        },
        onChangeMobileCheck(params) {
            const { id, value, fieldName } = params;
            this.changeMenuYnValue('mobile', id, fieldName, value);
        },
        onChangePremiumCheck(params) {
            const { id, value, fieldName } = params;
            this.changeMenuYnValue('premium', id, fieldName, value);
        },
        onClickAddAdditionalService() {
            this.editField.additionalServiceEmptyRows.push({
                name: '',
                price: '',
            });
        },
        getSendingParamsFromProduct(prod) {
            return {
                productType: prod.f_prod_type_cd,
                name: prod.f_namee,
                programProductType: prod.f_pg_type_cd,
                programProductPaymentType: prod.f_pg_pay_type_cd,
                usedPeriod: prod.f_use_period,
                price: Utils.getPureNumber(prod.f_price),
                menuScheduleYn: prod.f_m_schd_yn,
                menuCustomerYn: prod.f_m_cust_yn,
                menuLessonYn: prod.f_m_lesson_yn,
                menuSaleYn: prod.f_m_sale_yn,
                menuPayYn: prod.f_m_pay_yn,
                menuStatYn: prod.f_m_stat_yn,
                menuHistoryYn: prod.f_m_history_yn,
                menuBoardYn: prod.f_m_board_yn,
                menuTouchYn: prod.f_m_touch_yn,
                menuReservationYn: prod.f_m_resv_yn,
            };
        },
        onClickModifyProgram(id, programName) {
            if (!confirm('이 프로그램을 수정하시겠습니까?')) {
                return false;
            }

            let data = null;
            const list = this.product.program[programName];
            for (const l of list) {
                if (l.f_id == id) {
                    data = { ...l };
                    break;
                }
            }

            const params = this.getSendingParamsFromProduct(data);
            this.modifyProduct(params, id);
        },
        onClickModifyMms() {
            if (!confirm('문자서비스를 수정하시겠습니까?')) {
                return false;
            }

            const params = this.getSendingParamsFromProduct({
                ...this.product.mms,
            });
            console.log('mms params', params);
            this.modifyProduct(params, this.product.mms.f_id);
        },
        onClickModifyAdditionalService(id) {
            // 수정데이터 추출
            const rows = this.editField.additionalServiceRows;
            let rowData = null;
            for (const row of rows) {
                if (row.id == id) {
                    rowData = { ...row };
                    break;
                }
            }

            // 수정값 검증
            if (rowData.name.trim() === '') {
                alert('서비스명을 입력하세요.');
                return false;
            }
            if (rowData.price === '') {
                alert('금액을 입력하세요.');
                return false;
            }

            if (!confirm('이 부가서비스를 수정하시겠습니까?')) {
                return false;
            }

            const params = {
                productType: 'B',
                name: rowData.name,
                price: Utils.getPureNumber(rowData.price),
            };

            this.modifyProduct(params, rowData.id);
        },
        onClickPostAdditionalService(index) {
            const edit = this.editField.additionalServiceEmptyRows[index];

            const { name, price } = edit;

            if (name.trim() === '') {
                alert('서비스명을 입력하세요.');
                return false;
            }
            if (price === '') {
                alert('금액을 입력하세요.');
                return false;
            }

            if (!confirm('부가서비스를 등록하시겠습니까?')) {
                return false;
            }

            this.addAdditionalService(
                {
                    productType: 'B', // 부가서비스
                    name,
                    price,
                },
                index
            );
        },
        onClickDeleteAdditionalService(index) {
            if (!confirm('부가서비스를 삭제하시겠습니까?')) {
                return false;
            }

            this.deleteAdditionalService(index);
        },
        async deleteAdditionalService(index) {
            const row = this.editField.additionalServiceRows[index];
            console.log(index, row);
            const id = row.id;

            try {
                const { data } = await this.sendDeleteFtProduct(id);

                // 수정행에서 삭제
                this.$delete(this.editField.additionalServiceRows, index);

                // 데이터에서 삭제
                this.$delete(this.product.additional, index);

                alert('처리되었습니다');
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed Center create : ', error);
                console.log(centerData);
            }
        },
        async addAdditionalService(params, index) {
            try {
                const { data } = await this.sendPostFtProduct(params);

                // 등록행에서 제거
                this.$delete(this.editField.additionalServiceEmptyRows, index);

                // 수정행에 추가
                this.editField.additionalServiceRows.push({
                    name: data.name,
                    price: data.price,
                    id: data.id,
                });

                // 데이터에 추가
                // 2020.11.05 : 현재 최초 목록의 데이터 형태와 post때에 반환받는 데이터 형태가 다름
                this.product.additional.push(data);

                alert('처리되었습니다');
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed Center create : ', error);
                console.log(centerData);
            }
        },
        async modifyProduct(params, id) {
            try {
                const { data } = await this.sendPutFtProduct(params, id);

                // 부가서비스의 경우, 내부데이터의 처리가 필요하다.
                if (params.productType === 'B') {
                    console.log('부가서비스', data);
                }

                alert('처리되었습니다');
            } catch (error) {
                alert('오류가 발생했습니다.');
                console.log('===> Failed Center create : ', error);
                console.log(centerData);
            }
        },
        onChangeProductPrice(prod) {
            prod.f_price = Utils.getPureNumber(prod.f_price);

            prod.f_price = Utils.getNumberFormat(prod.f_price);
        },
        onChangeMmsPrice() {
            const { mms } = this.product;

            mms.f_price = Utils.getPureNumber(mms.f_price);
            mms.f_price = Utils.getNumberFormat(mms.f_price);
        },
        onChangeAddSrvPrice(prod) {
            prod.price = Utils.getPureNumber(prod.price);
            prod.price = Utils.getNumberFormat(prod.price);
        },
        isNumber(evt) {
            return Utils.isNumber(evt);
        },
        sendPutFtProduct(params, id) {
            return api.put(`/admin/api/ft/product/${id}`, {
                ...params,
            });
        },
        sendDeleteFtProduct(id) {
            return api.delete(`/admin/api/ft/product/${id}`);
        },
        sendPostFtProduct(params) {
            return api.post('/admin/api/ft/product', {
                ...params,
            });
        },
    },
};
</script>
<style lang="scss"></style>
